/**
 * Dependencies.
 */
import OrderTrackingModel from '@/api/order-tracking/order-tracking.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class OrderTrackingService extends BaseService<OrderTrackingModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      OrderTrackingModel,
      OrderTrackingModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }
}

/**
 * Export `orderTrackingService`.
 */
export const orderTrackingService = new OrderTrackingService();
